<template>
    <v-sheet>
        <v-toolbar dense class="mb-3" elevation="1" color="secondary" rounded>
            <v-breadcrumbs large :items="[
                { text: 'Sales and Distribution' },
                { text: 'Reports' },
                { text: 'Sales Agreements Report' },
            ]"> </v-breadcrumbs>
        </v-toolbar>
        <v-sheet elevation="1" rounded>
            <v-toolbar flat color="secondary">
                <v-toolbar-title>
                    Sales Agreements Summary Report
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <div class="mx-4">
                    <v-chip>{{this.from}}</v-chip>
                    <span class="mx-2">to</span>
                    <v-chip>{{this.to}}</v-chip>
                </div>
                <v-divider vertical></v-divider>
                <v-toolbar-items>
                     <v-btn icon @click="submit">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <v-btn depressed color="primary" @click="handleSearchDisplay">
                        <v-icon left>mdi-magnify</v-icon>
                        search
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <v-simple-table dense v-if="!hasErrors">
                <thead>
                    <tr class="font-weight-bold">
                        <th>Item Code</th>
                        <th>Item Name</th>
                        <th>Quantity</th>
                        <th>Delivered</th>
                        <th>Period Delivered</th>
                        <th>Average Price</th>
                        <th>Value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, i) in data" :key="i">
                        <td>{{d.item_code}}</td>
                        <td>{{d.item_name}}</td>
                        <td>{{formatNumber(d.quantity)}}</td>
                        <td>{{formatNumber(d.delieverd_total)}}</td>
                        <td>{{formatNumber(d.delivered_in_range)}}</td>
                        <td>{{formatNumber(d.average_price)}}</td>
                        <td>{{formatNumber(d.value)}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="font-weight-bold secondary">
                        <td colspan="2">Total</td>
                        <td>{{formatNumber(getTotal(data, "quantity"))}}</td>
                        <td>{{formatNumber(getTotal(data, "delieverd_total"))}}</td>
                        <td>{{formatNumber(getTotal(data, "delivered_in_range"))}}</td>
                        <td></td>
                        <td>{{formatNumber(getTotal(data, "value"))}}</td>
                    </tr>
                </tfoot>
            </v-simple-table>
            <div v-else class="pa-6 text-center surface">
                <div class="red--text my-1" v-for="(e, i) in errors" :key="i">{{e}}</div>
                <v-btn outlined class="mt-6" @click="submit">
                    <v-icon left>mdi-refresh</v-icon>
                    Try Again
                </v-btn>
            </div>
        </v-sheet>
        <v-dialog v-model="searchDisplay" max-width="350" persistent scrollable>
            <v-card>
                <v-card-title>Search</v-card-title>
                <v-card-text>
                    <v-form>
                        <v-subheader>Agreements Range</v-subheader>
                        <v-row>
                            <v-col>
                                <PDatePicker
                                    label="From"
                                    outlined
                                    hide
                                    v-model="form.from"
                                    />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <PDatePicker
                                    label="To"
                                    outlined
                                    hide
                                    v-model="form.to"
                                    />
                            </v-col>
                        </v-row>
                        <v-subheader>Invoices Range</v-subheader>
                        <v-row>
                            <v-col>
                                <PDatePicker
                                    label="From"
                                    outlined
                                    hide
                                    v-model="form.invoiceFrom"
                                    />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <PDatePicker
                                    label="To"
                                    outlined
                                    hide
                                    v-model="form.invoiceTo"
                                    />
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-row no-gutters>
                        <v-col class="me-1">
                            <v-btn color="primary" depressed block @click="submit" :loading="loading">
                                <v-icon>mdi-magnify</v-icon>
                                search
                            </v-btn>
                        </v-col>
                        <v-col class="ms-1">
                            <v-btn outlined block @click="searchDisplay = false">
                                Cancel
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <LoadingDialog message="Please Wait ..." v-model="loading"/>
    </v-sheet>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import PDatePicker from './../../components/common/PDatePicker';
import LoadingDialog from './../../components/common/LoadingDialog';
import { formatNumber } from 'accounting';
import { getTotal } from './../../utils/accounting';

export default {
    name: "SalesOrdersReportView",
    components: {
        PDatePicker,
        LoadingDialog
    },
    data() {
        return {
            form: {
                from: "",
                to: "",
                invoiceFrom: "",
                invoiceTo: ""
            },
            searchDisplay: false,
        }
    },
    computed: {
        ...mapGetters("sales/report/salesOrdersReport", [
            "loading", "data", "from", "to", "invoiceFrom", "invoiceTo", "errors", "hasErrors"
        ])
    },
    methods: {
        formatNumber(n) {
            return formatNumber(n, 2);
        },
        getTotal,
        ...mapActions({
            updateParams: "sales/report/salesOrdersReport/updateParams"
        }),
        handleSearchDisplay() {
            this.searchDisplay = true;
        },
        submit() {
            this.updateParams(this.form);
            this.searchDisplay = false;
        },
    },
    created() {
        this.form = {from: this.from, to: this.to, invoiceFrom: this.invoiceFrom, invoiceTo: this.invoiceTo};
        if(this.data.length == 0) this.submit();
    }
}
</script>
<style>

</style>